import { analyticsOnPurchase } from '@fd/common/auth/analytics';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CreateAccountForm } from '../blocks/CreateAccountForm';
import { PageBody, PageHeading } from '../layout/AppLayout';
import { h2ClassName, linkClassName } from '../components/ui/styles';
import { useAsyncEffect } from '../utils/useAsyncEffect';
import { useSession } from '../context/session/useSession';
import Gleap from 'gleap';
import { honoPrivateClient } from '../api/honoClient';

export function PaymentSuccessPage() {
  const [success, setSuccess] = useState(false);
  const { session } = useSession();
  const navigate = useNavigate();

  useAsyncEffect(async () => {
    const response = await honoPrivateClient.checkout.confirm.$post();
    setSuccess(true);
    if (response.status === 200) {
      const order = await response.json();
      if (typeof order !== 'string') {
        const orderWithDate = {
          ...order,
          paid_until: new Date(order.paid_until),
        };
        analyticsOnPurchase(session!.user!.email!, orderWithDate);
      }
      Gleap.trackEvent('Purchase', {
        userId: session?.user.id,
        email: session?.user.email,
        order: order,
      });
    }
    navigate('/proxy-pool/create?payment=success');
  }, []);

  if (!success) {
    return (
      <>
        <PageHeading>Waiting for payment information</PageHeading>
        <PageBody>
          <div className="">
            <h1 className={h2ClassName}>Processing payment information</h1>
            <p>Please wait.</p>
          </div>

          {!session && <CreateAccountForm />}
        </PageBody>
      </>
    );
  }
  return (
    <>
      <PageHeading>
        {success ? (
          <>Payment successful</>
        ) : (
          <>Waiting for payment information</>
        )}
      </PageHeading>
      <PageBody>
        <div className="">
          <div>
            <h1 className={h2ClassName}>Congratulations! Payment successful</h1>
            <p>
              Next step:{' '}
              <a className={linkClassName} href="/proxy-pool/create">
                create proxy pool and generate proxies
              </a>
              .
            </p>
          </div>
          <div></div>

          {!session && <CreateAccountForm />}
        </div>
      </PageBody>
    </>
  );
}
